export const LAST_PATH = 'LAST_PATH'
